import React from 'react';
import { Map } from 'lucide-react';
const servedZips = [{
  zip: '92373',
  name: 'Redlands',
  transactions: 62,
  rank: 1
}, {
  zip: '92399',
  name: 'Yucaipa',
  transactions: 48,
  rank: 2
}, {
  zip: '92346',
  name: 'Highland',
  transactions: 36,
  rank: 3
}, {
  zip: '92359',
  name: 'Mentone',
  transactions: 22,
  rank: 4
}, {
  zip: '92320',
  name: 'Calimesa',
  transactions: 18,
  rank: 5
}, {
  zip: '92324',
  name: 'Colton / Grand Terrace',
  transactions: 14,
  rank: 6
}];
export function MarketsServed() {
  return <section className="py-12 px-6 md:px-12 max-w-6xl mx-auto pt-[12px] pb-[12px]" data-id="element-137">
      <div className="bg-white rounded-3xl p-8 md:p-10 shadow-premium border border-brand-light" data-id="element-138">
        <div className="flex items-center gap-3 mb-8" data-id="element-139">
          <div className="w-12 h-12 rounded-full bg-brand-sage flex items-center justify-center text-brand-forest" data-id="element-140">
            <Map size={24} data-id="element-141" />
          </div>
          <div data-id="element-142">
            <h2 className="text-2xl font-serif text-brand-dark" data-id="element-143">
              Markets served
            </h2>
            <p className="text-sm text-brand-muted" data-id="element-144">
              ZIP-level performance across the Inland Empire
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-145">
          {servedZips.map(z => <div key={z.zip} className="flex items-center gap-3 px-4 py-3 bg-brand-sage/50 border border-brand-light rounded-xl hover:border-brand-forest/30 transition-colors" data-id="element-146">

              <div className="flex flex-col items-center justify-center w-12" data-id="element-147">
                <span className="font-mono text-sm font-medium text-brand-forest" data-id="element-148">
                  {z.zip}
                </span>
              </div>
              <div className="flex-1 min-w-0" data-id="element-149">
                <p className="text-sm font-medium text-brand-dark truncate" data-id="element-150">
                  {z.name}
                </p>
                <p className="text-xs text-brand-muted" data-id="element-151">
                  <span className="font-mono" data-id="element-152">{z.transactions}</span>{' '}
                  transactions · Rank #{z.rank}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}